<div class="rd-widget widget-{{widgetConfig.widgetId}} widget-two-columns-one-gap-fifty-percent rd-widget-no-height-restriction widgetNoTopBorder" *ngIf="widgetData">
  <div class="table-part">
    <table class="widget-flex table-widget" style="height: 100%;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tbody *ngIf="editMode">
        <ng-container *ngFor="let entry of widgetData.rows; let i = index; trackBy: trackById">
          <tr *ngIf="i < currentLayout">
            <td colspan="7" class="widget-td-onlyeditmode">
              <input type="text"     
              hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
              [elType]="'text'" [page]="page"  
              [editMode]="editMode" 
              (setNewValue)="entry.col1= $event;"
              id="td3fcol1{{i}}" [(ngModel)]="entry.col1" class="widget-input-text widget-align-left widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
            </td>
            <td colspan="1" class="space">&nbsp;</td>
            <td colspan="8" class="widget-td-onlyeditmode">
              <input type="text"     
              hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
              [elType]="'text'" [page]="page"  
              [editMode]="editMode" 
              (setNewValue)="entry.col2= $event;"
              id="td3fcol2{{i}}" [(ngModel)]="entry.col2" class="widget-input-text widget-align-right widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="!editMode" class="viewModeTbody">
        <ng-container *ngFor="let entry of widgetData.rows; let i = index; trackBy: trackById">
          <tr *ngIf="i < currentLayout">
            <td colspan="7" class="widget-td-onlyviewmode widget-input-text widget-h1 widget-align-left"><widget-value [align]="'left'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.col1}}</label></widget-value></td>
            <td colspan="1" class="space">&nbsp;</td>
            <td colspan="8" class="widget-td-onlyviewmode widget-input-text widget-h1 widget-align-right"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.col2}}</label></widget-value></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="space-part">&nbsp;</div>
  <div class="table-part">
    <table class="widget-flex table-widget" style="height: 100%;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tbody *ngIf="editMode">
        <ng-container *ngFor="let entry of widgetData.rows; let i = index; trackBy: trackById">
          <tr *ngIf="i < currentLayout">
            <td colspan="7" class="widget-td-onlyeditmode">
              <input type="text"     
              hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
              [elType]="'text'" [page]="page"  
              [editMode]="editMode" 
              (setNewValue)="entry.col3= $event;"
              id="td3fcol3{{i}}" [(ngModel)]="entry.col3" class="widget-input-text widget-align-left widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
            </td>
            <td colspan="1" class="space">&nbsp;</td>
            <td colspan="8" class="widget-td-onlyeditmode">
              <input type="text"     
              hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
              [elType]="'text'" [page]="page"  
              [editMode]="editMode" 
              (setNewValue)="entry.col4= $event;"
              id="td3fcol4{{i}}" [(ngModel)]="entry.col4" class="widget-input-text widget-align-right widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="!editMode" class="viewModeTbody">
        <ng-container *ngFor="let entry of widgetData.rows; let i = index; trackBy: trackById">
          <tr *ngIf="i < currentLayout">
            <td colspan="7" class="widget-td-onlyviewmode widget-input-text widget-h1 widget-align-left"><widget-value [align]="'left'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.col3}}</label></widget-value></td>
            <td colspan="1" class="space">&nbsp;</td>
            <td colspan="8" class="widget-td-onlyviewmode widget-input-text widget-h1 widget-align-right"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.col4}}</label></widget-value></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
